import { GiftCardConfirmationScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <GiftCardConfirmationScreen />;
}
